import React from 'react';
import { usePageData } from '../PageData';
import Carousel from '../prematch/top-match/Carousel';

export default function LandingCarousel() {
    const data = usePageData();

    if (data == null) {
        return null;
    }

    return (
        <>
            {data.carouselBanners?.length > 0 &&
                <Carousel banners={data.carouselBanners} />
            }
        </>
    );
}
